import { supabase } from "../supaBaseClient";
 
export const fetchCategories = (onResponse: any) => {
  return async () => {
    try {
      const { data: categories, error } = await supabase.from("categories").select(`
        id,
        name,
        description`);
      if (error) throw error;
      const obj = {
        status: "info",
        data: categories,
      };
      onResponse(obj);
    } catch (error) {
      const obj = {
        status: "error",
        message: "Technical error occurred, contact administrator.",
        error,
      };
      onResponse(obj);
    }
  };
}

export const fetchAllProducts = (onResponse: any) => {
  return async () => {
    try {
      const { data: products, error } = await supabase.from("products").select(`
        id,
        name,
        category: category_id(name),
        supplier: supplier_id(name),
        quantity,
        buying_price,
        selling_price,
        offer_status,
        volume,
        image_url,
        updated_at`);
      if (error) throw error;
      const obj = {
        status: "info",
        data: products,
      };
      onResponse(obj);
    } catch (error) {
      const obj = {
        status: "error",
        message: "Technical error occurred, contact administrator.",
        error,
      };
      onResponse(obj);
    }
  };
};

export const fetchlatestProducts = (onResponse: any) => {
  return async () => {
    try {
      const { data: products, error } = await supabase.from("products").select(`
        id,
        name,
        selling_price,
        image_url,
        updated_at`).order('updated_at', { ascending: false }).range(0,11);
      if (error) throw error;
      const obj = {
        status: "info",
        data: products,
      };
      onResponse(obj);
    } catch (error) {
      const obj = {
        status: "error",
        message: "Technical error occurred, contact administrator.",
        error,
      };
      onResponse(obj);
    }
  };
};

export const fetchlatestcategorisedProducts = (category_id: number, onResponse: any) => {
  return async () => {
    try {
      const { data: products, error } = await supabase.from("products").select(`
        id,
        name,
        selling_price,
        image_url,
        updated_at`).eq("category_id", category_id).order('updated_at', { ascending: false }).range(0,2);
      if (error) throw error;
      const obj = {
        status: "info",
        data: products,
      };
      onResponse(obj);
    } catch (error) {
      const obj = {
        status: "error",
        message: "Technical error occurred, contact administrator.",
        error,
      };
      onResponse(obj);
    }
  };
};

// const { data, count } = supabase
//   .from('countries')
// //   .select('*', { count: 'exact' })

// const { data, error } = await supabase
//   .from('cities')
//   .select('name, country_id')
//   .limit(1)
//   .single()

export const fetchCategoryProducts = (category_id:number, onResponse: any) => {
  return async () => {
    try {      
      const { data: products, error } = await supabase.from("products").select(`
      id,
      name,
      category: category_id(name),
      supplier: supplier_id(name),
      quantity,
      buying_price,
      selling_price,
      offer_status,
      volume,
      image_url,
      updated_at`).eq("category_id", category_id);
      if (error) throw error;
      const obj = {
        status: "info",
        data: products,
      };
      onResponse(obj);
    } catch (error) {
      const obj = {
        status: "error",
        message: "Technical error occurred, contact administrator.",
        error,
      };
      onResponse(obj);
    }
  };
};

export const fetchAdditionalProductInfo = (onResponse: any) => {
  return async () => {
    try {
      const { data: suppliers, error } = await supabase.from("suppliers")
        .select(`
          id,
          name`);
      const { data: categories } = await supabase.from("categories").select(`
          id,
          name`);
      if (error) throw error;
      const obj = {
        status: "info",
        suppliers: suppliers,
        categories: categories,
      };
      onResponse(obj);
    } catch (error) {
      const obj = {
        status: "error",
        message: "Technical error occurred, contact administrator.",
        error,
      };
      onResponse(obj);
    }
  };
};

export const fetchSingleProduct = (product_id: any, onResponse: any) => {
  return async () => {
    try {
      const { data: product, error } = await supabase
        .from("products")
        .select(
          `
          name,
          category: category_id(name),
          supplier: supplier_id(name),
          quantity,
          buying_price,
          selling_price,
          discount_rate,
          offer_status,
          volume,
          description,
          alcohol_percentage,
          image_url
          `
        )
        .eq("id", product_id);
      const { data: categories } = await supabase.from("categories");

      if (error) throw error;
      const obj = {
        status: "info",
        data: product,
        categories: categories,
      };
      onResponse(obj);
    } catch (error) {
      const obj = {
        status: "error",
        message: "Technical error occurred, contact administrator.",
        error,
      };
      onResponse(obj);
    }
  };
};
 

// export const checkOutCart = (data: any,onResponse: any)=>{
//   return ()=>{
//       Api.post(`${APIBASEURL}/customer/checkout`,data).then(response=>{
//           const data = response.data;
//           onResponse(data)
//       }).catch(error=>{
//           const obj = {
//               status : "error",
//               message  : "Technical error occurred, contact administrator.",
//               error
//           }
//           onResponse(obj)
//       })
//   }
// }
